import React from "react";
import {GreetMessageTab} from "../greet-messages/GreetMessageTab";
import {SettingsTab} from "../settings/SettingsTab";
import {StaticRoutesTab} from "../routes/StaticRoutesTab";
import {DynamicRoutesTab} from "../routes/DynamicRoutesTab";
import {KnowledgeBaseTab} from "../knowledge-base/KnowledgeBaseTab";
import {VarsTab} from "../vars/VarsTab";
import {PleaseWaitMessagesTab} from "../please-wait-messages/PleaseWaitMessagesTab";
import {SlotsTab} from "../slots/SlotsTab";
import {OutputParserTab} from "../output-parser/OutputParserTab";
import {LLMBoostTab} from "../llm-booster/LLMBoostTab";
import {FilterTab} from "../filter/FilterTab";
import {SettingsBoosterTab} from "../settings-booster/SettingsBoosterTab";
import {InputParamsTab} from "../input_params/InputParamsTab";
import {OutputParamsTab} from "../output_params/OutputParamsTab";
import {SettingsToolsTab} from "../settings-tools/SettingsToolsTab";
import {SupervisionLearningTab} from "../supervision_learning/SupervisionLearningTab";
import {InputArgsTab} from "../input-args/InputArgsTab";
import {SettingsRefactoredTab} from "../settings/SettingsRefactoredTab";
import {LLMConfigurationTab} from "../llm-configuration/LllmConfigurationTab";
import {VoiceParametersTab} from "../voice-parameters/VoiceParametersTab";

/**
 * Resolves the active `value` (edit-menu tab key) to its tab component.
 * Kept out of EditNodeMenu so that file only owns layout.
 */
export const NodeTabContent = ({value, node, setNode, onUpdate, onChangeData, nodes, project, flow, selectedRoute}) => {
    const tabs = {
        vars: <VarsTab node={node} setNode={setNode} project={project} onUpdate={onUpdate} flow={flow}/>,
        greet: <GreetMessageTab node={node} setNode={setNode} project={project} flow={flow} onUpdate={onUpdate}/>,
        please_wait_messages: <PleaseWaitMessagesTab node={node} setNode={setNode} onUpdate={onUpdate}/>,
        slots: <SlotsTab node={node} setNode={setNode} onUpdate={onUpdate} project={project} onChangeData={onChangeData}/>,
        settings: <SettingsTab node={node} setNode={setNode} onUpdate={onUpdate} nodes={nodes} project={project}/>,
        supervision_learning: (
            <SupervisionLearningTab node={node} setNode={setNode} nodes={nodes} onUpdate={onUpdate}
                                    onChangeData={onChangeData} project={project}/>
        ),
        settings_booster: (
            <SettingsBoosterTab node={node} flow={flow} setNode={setNode} nodes={nodes} onUpdate={onUpdate}
                                onChangeData={onChangeData} project={project}/>
        ),
        settings_tools: (
            <SettingsToolsTab node={node} setNode={setNode} nodes={nodes} onUpdate={onUpdate}
                              onChangeData={onChangeData} project={project}/>
        ),
        knowledge_base: <KnowledgeBaseTab node={node} setNode={setNode} onUpdate={onUpdate} project={project}/>,
        output_parser: (
            <OutputParserTab node={node} setNode={setNode} onUpdate={onUpdate} onChangeData={onChangeData}
                             project={project}/>
        ),
        input_params: (
            <InputParamsTab node={node} setNode={setNode} onUpdate={onUpdate} onChangeData={onChangeData}
                            project={project}/>
        ),
        output_params: (
            <OutputParamsTab node={node} setNode={setNode} onUpdate={onUpdate} onChangeData={onChangeData}
                             project={project}/>
        ),
        llm_boost: (
            <LLMBoostTab node={node} setNode={setNode} onUpdate={onUpdate} onChangeData={onChangeData} project={project}/>
        ),
        static: (
            <StaticRoutesTab node={node} setNode={setNode} nodes={nodes} onUpdate={onUpdate} flow={flow}
                             project={project} selectedRoute={selectedRoute}/>
        ),
        dynamic: (
            <DynamicRoutesTab node={node} setNode={setNode} nodes={nodes} onUpdate={onUpdate} project={project}
                              flow={flow} selectedRoute={selectedRoute}/>
        ),
        filter: (
            <FilterTab node={node} setNode={setNode} nodes={nodes} onUpdate={onUpdate} project={project} flow={flow}
                       selectedRoute={selectedRoute}/>
        ),
        input_args: (
            <InputArgsTab node={node} setNode={setNode} nodes={nodes} onUpdate={onUpdate} project={project} flow={flow}
                          selectedRoute={selectedRoute}/>
        ),
        settings_refactored: <SettingsRefactoredTab node={node} setNode={setNode} onUpdate={onUpdate}/>,
        llm_configuration: (
            <LLMConfigurationTab node={node} setNode={setNode} onUpdate={onUpdate} project={project} nodes={nodes}
                                 flow={flow}/>
        ),
        voice_parameters: (
            <VoiceParametersTab node={node} setNode={setNode} onUpdate={onUpdate} project={project} nodes={nodes}/>
        ),
    };

    return tabs[value] || null;
};
